import React from 'react';
import { ReactComponent as TruckbaseLogo } from '../../assets/truckbase-logo.svg';
import { ReactComponent as ClockIcon } from '../../assets/icons/clock-icon.svg';
import Typography from '@mui/material/Typography';
import usePageTitle from '../../hooks/usePageTitle';
import { TwButton, TwButtonType } from '../../components/TwButtons/TwButtons';
import { useNavigate } from 'react-router-dom';
import './AlreadySignedUp.scss';

const AlreadySignedUp: React.FC = (): JSX.Element => {
  usePageTitle('Already signed up | Truckbase');
  const navigate = useNavigate();

  const goToSignIn = (): void => {
    navigate('/signin');
  };

  return (
    <div className="already-signed-up__wrapper">
      <header className="already-signed-up__header">
        <TruckbaseLogo width={200} />
      </header>
      <div className="already-signed-up__content">
        <ClockIcon className="already-signed-up__icon" />
        <Typography variant="h5" className="already-signed-up__title">
          Looks like you have already signed up.
        </Typography>
        <Typography variant="body1" className="already-signed-up__description">
          Sign in to get started with Truckbase or ask your admin for new login.
        </Typography>
        <div className="create-password-success__submit-button">
          <TwButton label="Sign in" type={TwButtonType.primary} action={goToSignIn} />
        </div>
      </div>
    </div>
  );
};

export default AlreadySignedUp;
